module.exports = __webpack_public_path__ + "static/img/ptzs1.ae36ada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ptzs1.png
// module id = +41+
// module chunks = 0